import { render, staticRenderFns } from "./addKomisaris.vue?vue&type=template&id=36be0cfd&scoped=true&"
import script from "./addKomisaris.vue?vue&type=script&lang=js&"
export * from "./addKomisaris.vue?vue&type=script&lang=js&"
import style0 from "./addKomisaris.vue?vue&type=style&index=0&id=36be0cfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be0cfd",
  null
  
)

export default component.exports